export default __webpack_public_path__ + "static/media/facebook.184659b1.svg";